import { ResponsiveContainer } from "recharts";
import styled, { css } from "styled-components";

export const DashboardContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

export const TopSection = styled.div`
	background-color: #fff;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem 1rem 1rem 0;
	margin-left: 5rem;
	margin-right: 5rem;
	border-bottom: 1px solid #efefef;
`;

export const BodySection = styled.div`
	width: 100%;
	padding-top: 1rem;
	${({ ispdf }) =>
		!ispdf &&
		css`
			overflow: scroll;
			overflow-x: hidden;
			max-height: calc(100vh - 155px);
		`}
        `;

export const Body = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding-left: 5rem;
	padding-right: 5rem;
`;

export const CustomResponsiveContainer = styled(ResponsiveContainer)`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const LegendText = styled.div`
	color: #605f60;
	font-family: "Inter";
	font-size: 0.75rem;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
`;

export const CustomTooltip = styled.div`
	display: flex;
	justify-content: center;
	border: 1px solid #ccc;
	min-width: 120px;
	font-family: "Inter";
	font-size: 14px;
`;

export const ColorCircle = styled.div`
	min-width: 0.75rem;
	min-height: 0.75rem;
	border-radius: 6.25rem;
	border: 1px solid ${(props) => props.color};
	background: ${(props) => props.color};
`;

export const TickStyle = {
	fontSize: "14px",
	fontFamilly: "Inter",
	color: "#605F60",
};

export const RelativeWrapper = styled.div`
	position: relative;
	min-height: 800px;
`;

export const AnalyticsLogoHeader = styled.img`
	object-fit: contain;
	background-color: #ffffff;
	overflow: hidden;
    max-height: 100px;
    max-width: 380px;
    align-self: flex-start;
    margin-left: 5rem;
`;